import { web } from "./middleware";

export const TaskManagementApi = {
  getMitTasks: () => web({ url: "/tasks/mit-lists", method: "GET" }),
  getDoTasks: () => web({ url: "/tasks/do-lists", method: "GET" }),
  changeTaskLevel: (taskId, reqBody) =>
    web({ url: `/tasks/${taskId}/change-level`, method: "PATCH" }, reqBody),
  markSubtaskAsCompleted: (taskId, subtaskId) =>
    web({
      url: `/tasks/${taskId}/subtasks/${subtaskId}/mark-as-completed`,
      method: "PATCH",
    }),
  deleteSubtask: (subtaskId) =>
    web({ url: `/subtasks/${subtaskId}`, method: "DELETE" }),
  getTasksByDate: (date) =>
    web({ url: `/tasks`, method: "GET", params: { date } }),
  getTaskEnums: () => web({ url: "/tasks/enums", method: "GET" }),
  getTaskById: (taskId) => web({ url: `/tasks/${taskId}`, method: "GET" }),
  createTask: (payload) => web({ url: "/tasks", method: "POST" }, payload),
  updateTask: (taskId, payload) =>
    web({ url: `/tasks/${taskId}`, method: "PUT" }, payload),
  getDoneAchievedTasks: (params = null) =>
    web({ url: "/tasks/today-completed", method: "GET" }, params),
  deleteTask: (taskId, payload = {}) => {
    // Convert payload to query parameters for DELETE requests
    const queryParams = new URLSearchParams();
    if (payload.delete_all) queryParams.append("delete_all", "true");
    if (payload.delete_this_and_future)
      queryParams.append("delete_this_and_future", "true");
    if (payload.delete_this_only)
      queryParams.append("delete_this_only", "true");

    const url = queryParams.toString()
      ? `/tasks/${taskId}?${queryParams.toString()}`
      : `/tasks/${taskId}`;
    return web({ url, method: "DELETE" });
  },
  reorderSubtasks: (taskId, reqBody) =>
    web({ url: `/tasks/${taskId}/subtasks/reorder`, method: "POST" }, reqBody),
  getGoogleConnectUrl: () =>
    web({ url: "user/google/connect-url?platform=web", method: "GET" }),
  disconnectGoogle: () =>
    web({ url: "user/google/disconnect", method: "POST" }),
};
